import React from "react";
import "./module-header.scss";

export { default as ModuleHeaderAction } from "./ModuleHeaderAction";
export { default as ModuleHeaderBack } from "./ModuleHeaderBack";

const DEFAULT_EYEBROW = "SecondBite Merchant";

/**
 * Shared page header for every merchant module.
 * Visual template: brand-700 bar + eyebrow + title + copy + actions.
 */
const ModuleHeader = ({
  eyebrow = DEFAULT_EYEBROW,
  title,
  description,
  actions = null,
  back = null,
  variant = "default",
  bleed = false,
  className = "",
  as: Tag = "section",
}) => {
  const rootClass = [
    "module-header",
    variant === "danger" ? "module-header--danger" : "",
    bleed ? "module-header--bleed" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={rootClass}>
      <div className="module-header__body">
        {back ? <div className="module-header__back">{back}</div> : null}
        {eyebrow ? <p className="module-header__eyebrow">{eyebrow}</p> : null}
        {title ? <h2 className="module-header__title">{title}</h2> : null}
        {description ? <p className="module-header__description">{description}</p> : null}
      </div>

      {actions ? <div className="module-header__actions">{actions}</div> : null}
    </Tag>
  );
};

export default ModuleHeader;
